import Service, { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import config from 'linced-app/config/environment';

export default class HeroApiSlotsService extends Service {
  @service
  fetch;

  @service
  store;

  block(id) {
    return this._statusAction(id, 'block');
  }

  release(id) {
    return this._statusAction(id, 'release');
  }

  _statusAction(id, action) {
    return this.fetch
      .post(`${config.APP.apiHost}/bookings/v4/slots/${id}/:${action}`)
      .then((response) => {
        if (!isEmpty(response.slot)) {
          this.store.pushPayload('bookings/slot', response);
        }
        return Promise.resolve();
      });
  }
}
